// Utility functions for community events
import { formatDate as formatDateUtil, formatTime as formatTimeUtil } from './utils/dateUtils';

// Re-export the centralized date/time formatters
export const formatDate = formatDateUtil;
export const formatTime = formatTimeUtil;

export const getEventTypeInfo = (event) => {
  switch(event.eventType) {
    case 2: // Art
      return { type: 'public_activity', label: 'Art', color: '#9c27b0', icon: '🎨', requiredVotes: 5 };
    case 3: // Music
      return { type: 'public_activity', label: 'Music', color: '#e91e63', icon: '🎵', requiredVotes: 5 };
    case 4: // Sport
      return { type: 'public_activity', label: 'Sport', color: '#4caf50', icon: '⚽', requiredVotes: 5 };
    case 5: // PersonalGathering
      return { type: 'personal', label: 'Personal', color: '#607d8b', icon: '👥', requiredVotes: 0 };
    case 1: // CommunityWork
    default:
      return { type: 'community_work', label: 'Community Work', color: '#ff9800', icon: '🔨', requiredVotes: 2 };
  }
};

export const formatAttendance = (event, t) => {
  if (event.fixedAttendance) {
    return t ? t('communityEventCard.attendance.fixed', { count: event.fixedAttendance }) : `👥 Fixed: ${event.fixedAttendance} people`;
  }
  if (event.minAttendance) {
    return t ? t('communityEventCard.attendance.min', { count: event.minAttendance }) : `👥 Min: ${event.minAttendance} people`;
  }
  if (event.maxAttendance) {
    return t ? t('communityEventCard.attendance.max', { count: event.maxAttendance }) : `👥 Max: ${event.maxAttendance} people`;
  }
  return null;
};
